import api from "./api";

// =======================================================
// 📁 Services Documents - ShemsPaie
// =======================================================

const normalizeModule = (module) => {
  return String(module || "").trim().toLowerCase();
};

const buildFormData = ({
  file,
  module,
  moduleId,
  categorie = "",
  description = "",
}) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("module", normalizeModule(module));
  formData.append("module_id", moduleId);
  formData.append("categorie", categorie || "");
  formData.append("description", description || "");

  return formData;
};

const getDocumentsByModule = async (module, moduleId) => {
  const response = await api.get(
    `/documents/${normalizeModule(module)}/${moduleId}`
  );
  return response.data;
};

const getDocumentById = async (id) => {
  const response = await api.get(`/documents/id/${id}`);
  return response.data;
};

const getDocumentsStats = async (module, ids = []) => {
  const response = await api.post(`/documents/stats`, {
    module: normalizeModule(module),
    ids,
  });
  return response.data;
};

const uploadDocument = async ({
  file,
  module,
  moduleId,
  categorie = "",
  description = "",
}) => {
  const formData = buildFormData({
    file,
    module,
    moduleId,
    categorie,
    description,
  });

  const response = await api.post("/documents/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const deleteDocument = async (id) => {
  const response = await api.delete(`/documents/${id}`);
  return response.data;
};

const downloadDocument = async (id, fallbackFileName = "document") => {
  const response = await api.get(`/documents/download/${id}`, {
    responseType: "arraybuffer",
  });

  let fileName = fallbackFileName;
  const contentDisposition = response.headers["content-disposition"];

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/i);
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  const contentType =
    response.headers["content-type"] || "application/octet-stream";

  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);

  return true;
};

const getDocumentBlob = async (id) => {
  const response = await api.get(`/documents/download/${id}`, {
    responseType: "arraybuffer",
  });

  const contentType =
    response.headers["content-type"] || "application/octet-stream";

  return new Blob([response.data], { type: contentType });
};

const getDocumentObjectUrl = async (id) => {
  const blob = await getDocumentBlob(id);
  return window.URL.createObjectURL(blob);
};

const documentService = {
  getDocumentsByModule,
  getDocumentById,
  getDocumentsStats,
  uploadDocument,
  deleteDocument,
  downloadDocument,
  getDocumentBlob,
  getDocumentObjectUrl,
};

export default documentService;